module.exports = __webpack_public_path__ + "static/media/Transcription.9b0cf2a8.png";